const portal_errorMessageMap = {
  30001: "该应用不存在，请检查请求的参数或者应用ID",
  40001: "当前获取的位置信息错误，未知",
  40002: "当前获取的位置信息错误，未知",
  40003: "登录信息变化，请刷新页面或重新登录后操作",
  40004: "模板路径不存在",
  40005: "未知的数据中心产品类型",
  40006: "修改的云舟配置不存在",
  40007: "应用引用的同源应用不存在",
  40008: "暂无权限，COOKIE校验不通过或UID为空",
  40009: "登录信息变化，请刷新页面或重新登录后操作",
  40010: "网站不存在！",
  50001: "不允许当前url地址访问",
  50002: "当前请求内容解码错误，如decode",
  50003: "当前请求空指针异常",
  50004: "请求url时传递的参数错误",
  50005: "数据内容中出现格式转换错误，比如数字转换，日期转换等",
  50006: "分类数据不存在",
  50007: "数据不存在",
  50008: "操作数据失败",
  50009: "外部数据源请求异常",
  50010: "外部数据源返回格式错误",
  50011: "分类接口请求异常",
  50012: "分类接口返回格式错误",
  50013: "搜索接口请求异常",
  50014: "搜索接口返回格式错误",
  50015: "搜索类型接口请求异常",
  50016: "搜索类型接口返回格式错误",
  50017: "未配置详情页地址",
  50018: "未配置详情接口返回格式错误",
  50019: "内部接口调用异常，请联系管理员",
  50020: "参数不正确",
  50021: "参数不正确",
  50022: "含敏感信息",
  50023: "名称重复",
  50024: "无法获取视频封面",
  50025: "视频帧数不能小于1",
  50026: "接口数据请求异常",
  50027: "表单接口数据请求异常",
  50028: "外部快捷入口数据源接口不正确",
  50029: "单位区域架构未激活",
  50030: "网站在线人数统计设置保存失败",
  50031: "IP验证失败",
  50032: "存在子分类的分类不能添加数据",
  50033: "目前支持最大分类层级为5级",
  50034: "引擎类型不存在",
  50035: "审核中的数据不能修改",
  50036: "审核不通过的数据不能发布",
  50037: "待提交审核的数据不能发布",
  50038: "不能审核待提交审核的数据",
  50039: "该条数据已审核通过",
  50040: "该条数据已被提交审核",
  50041: "该条数据已被审核,撤回失败",
  50042: "非本单位的应用",
  50043: "请下载最新的模版",
  50044: "云舟接口获取数据失败",
  50045: "重复提交",
  50046: "cookie异常或当前产品类型不正确",
  50047: "不能删除网站首页",
  50048: "该网站已设置为系统模板",
  50049: "plugs.json文件读取异常",
  50050: "非法IP",
  50051: "当前网站不是最新版本，请刷新后操作",
  50052: "网站类型错误",
  50053: "页面不存在",
  50054: "审核中的页面不能修改",
  50055: "审核不通过的页面不能发布",
  50056: "待提交审核的页面不能发布",
  50057: "不能审核待提交审核的页面",
  50058: "该页面已审核通过",
  50059: "该页面已被提交审核",
  50060: "该页面已被审核,撤回失败",
  50061: "审核的页面不存在",
  50062: "文化馆开通类型错误",
  50063: "cookie获取错误",
  50064: "webJson解析错误",
  50066: "请求来源错误",
  50067: "组件类型错误",
  50068: "网站域名和cookie不一致",
  50069: "JSON解析错误",
  50070: "当前网站不是最新版本，请刷新后操作",
  50071: "当前网站不是最新版本，请刷新后操作",
  50072: "链接超时，请重新进入",
  50073: "单位网站数量超过最大值",
  50074: "JSON不能为空",
  50075: "系统默认组件未配置",
  50076: "系统默认组件ID配置错误",
  50077: "URL解码错误",
  50078: "选择主题包PAGE_THEME_ID错误,PAGE_THEME_ID不能为0",
  50079: "非法创建站点",
  50080: "pageId和websiteId关系错误",
  50081: "组件存在默认组件类型依赖关系，先修改组件类型的默认组件ID后再删除",
  50082: "cookie中的websiteId和当前网站不一致",
  50083: "2.0列表页或详情页pageId所属网站不存在",
  50084: "PC端webjson内容不能超过3MB",
  50085: "APP端webjson内容不能超过3MB",
  50086: "无组件删除权限",
  50087: "无组件新增权限",
  50088: "网站存在单个页面应用数超过50个",
  50089: "2.0网站存在单个列表或详情页面应用数超过10个",
  50090: "大屏网站存在单个页面应用数超过100个"
}
const engine_errorMessageMap = {
  30001: "该应用不存在，请检查请求的参数或者应用ID",
  40001: "当前获取的位置信息错误，未知",
  40002: "数据中心不存在该记录",
  40003: "暂无权限，可能是不在ip内、应用有访问限制、单位切换、登录过期导致",
  40004: "模板路径不存在",
  40005: "当前获取的位置信息错误，未知",
  40006: "修改的云舟配置不存在",
  40007: "应用引用的同源应用不存在",
  40008: "数据中心配置参数不存在",
  40009: "此页面不存在该应用",
  40010: "需要开通表单使用权限，如果是映射表单可在后台开通",
  50001: "不允许当前url地址访问",
  50002: "当前请求内容解码错误，如decode",
  50003: "当前请求空指针异常",
  50004: "请求url时传递的参数错误",
  50005: "数据内容中出现格式转换错误，比如数字转换，日期转换等",
  50006: "分类数据不存在",
  50007: "数据不存在",
  50008: "操作数据失败",
  50009: "外部数据源请求异常，数据源地址无法请求",
  50010: "外部数据源返回格式错误",
  50011: "分类接口请求异常",
  50012: "分类接口返回格式错误",
  50013: "搜索接口请求异常",
  50014: "搜索接口返回格式错误，缺少curPage、totalPages、results等属性",
  50015: "搜索类型接口请求异常",
  50016: "搜索类型接口返回格式错误",
  50017: "未配置详情页地址",
  50018: "未配置详情接口返回格式错误",
  50019: "内部接口调用异常，请联系管理员",
  50020: "参数不正确",
  50021: "参数不正确",
  50022: "含敏感信息",
  50023: "名称重复",
  50024: "无法获取视频封面",
  50025: "视频帧数不能小于1",
  50026: "接口数据请求异常",
  50027: "表单接口数据请求异常",
  50028: "外部快捷入口数据源接口不正确",
  50029: "单位区域架构未激活",
  50030: "网站在线人数统计设置保存失败",
  50031: "IP验证失败",
  50032: "存在子分类的分类不能添加数据",
  50033: "目前支持最大分类层级为5级",
  50034: "引擎类型不存在",
  50035: "审核中的数据不能修改",
  50036: "审核不通过的数据不能发布",
  50037: "待提交审核的数据不能发布",
  50038: "不能审核待提交审核的数据",
  50039: "该条数据已审核通过",
  50040: "该条数据已被提交审核",
  50041: "该条数据已被审核,撤回失败",
  50042: "非本单位的应用",
  50043: "请下载最新的模版",
  50044: "云舟接口获取数据失败",
  50045: "重复提交",
  50046: "该应用不存在，页面头部已开通",
  50047: "请先删除关联该分类下的所有内容",
  50048: "URL格式错误",
  50049: "数据引用错误",
  50050: "熔断错误",
  50051: "熔断错误",
  50052: "非法IP",
  50066: "数据中心不存在该记录",
  50067: "搜索应用无数据",
  50068: "该应用不存在",
  50069: "检索字段与检索关键字数量不匹配",
  50070: "外部数据源请求超时",
  50071: "外部数据源分类地址请求超时",
  50072: "外部数据源分类地址无法请求",
  50073: "cookie数字转换错误",
  50074: "数字转换错误",
  50075: "分类不属于此应用",
  50076: "返回数据为空"
}
export const getErrorMessage = (message, noTipMessage) => {
  if (!message) return ""
  let codeReg = /^mh_portal_(\d+)$/
  let errorMessageMap = portal_errorMessageMap
  if (message.indexOf("engine") > -1) {
    codeReg = /^mh_engine_(\d+)$/
    errorMessageMap = engine_errorMessageMap
  } else {
    codeReg = /^mh_portal_(\d+)$/
    errorMessageMap = portal_errorMessageMap
  }
  const matchResult = codeReg.exec(message)
  if (matchResult) {
    return errorMessageMap[matchResult[1]] || (noTipMessage ? "" : message)
  }
  return noTipMessage ? "" : message
}
